/* =============================================================================
   assets/sg-length-guide.js
   Seconda Golf — Club Length Guide

   Three behaviours, all optional. If this file never runs the page still
   works: every step is readable, the diagram is fully drawn, the chart is
   visible at its normal size, and nothing is hidden.

   1. Step highlighting. Choosing a measure step dims the diagram and lifts
      the part named in the step's data-focus attribute (set in the Liquid).

   2. Enlarged chart. Clicking the chart opens it full size. Escape, the
      close button and a click on the backdrop all close it; focus returns
      to the chart and the page behind does not scroll while it is open.

   3. Scroll reveal. Runs ONLY when the section setting "Fade sections in on
      scroll" is ticked (data-reveal="true" on the wrapper). The CSS only
      hides anything inside .sg-anim, which this script adds, so a failure
      can never leave content invisible.

   NO CUSTOMER-FACING TEXT LIVES IN THIS FILE.
   ============================================================================= */

(function () {
  'use strict';

  var svg   = document.getElementById('sg-len-svg');
  var steps = document.getElementById('sg-len-steps');
  var root  = document.querySelector('.sg-len');
  if (!root) { return; }

  var reduceMotion = window.matchMedia &&
                     window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── 1. Step highlighting ─────────────────────────────────────────────── */
  if (svg && steps) {
    var btns = steps.querySelectorAll('button[data-focus]');
    var held = null;

    function paint(focus) {
      if (focus && focus !== 'all') {
        svg.setAttribute('data-active', focus);
      } else {
        svg.removeAttribute('data-active');
      }
    }

    function markPressed(active) {
      Array.prototype.forEach.call(btns, function (b) {
        var on = (b === active);
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    Array.prototype.forEach.call(btns, function (btn) {
      var f = btn.getAttribute('data-focus');

      btn.addEventListener('click', function () {
        if (held === btn) {
          held = null;
          markPressed(null);
          paint(null);
        } else {
          held = btn;
          markPressed(btn);
          paint(f);
        }
      });

      btn.addEventListener('mouseenter', function () { if (!held) { paint(f); } });
      btn.addEventListener('focus',      function () { if (!held) { paint(f); } });
      btn.addEventListener('mouseleave', function () { if (!held) { paint(null); } });
      btn.addEventListener('blur',       function () { if (!held) { paint(null); } });
    });
  }

  /* ── 2. Enlarged chart ────────────────────────────────────────────────── */
  var lb = document.getElementById('sg-chart-lb');
  if (lb) {
    var lbOpen  = document.getElementById('sg-chart-open');
    var lbClose = document.getElementById('sg-chart-close');
    var lbLast  = null;
    var lbPrevOverflow = '';

    function lbShow() {
      lbLast = document.activeElement;
      lb.classList.add('open');
      lb.setAttribute('aria-hidden', 'false');
      lbPrevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      lbClose.focus();
    }

    function lbHide() {
      lb.classList.remove('open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = lbPrevOverflow;
      if (lbLast && typeof lbLast.focus === 'function') { lbLast.focus(); }
    }

    if (lbOpen) { lbOpen.addEventListener('click', lbShow); }
    lbClose.addEventListener('click', lbHide);
    lb.addEventListener('click', function (e) { if (e.target === lb) { lbHide(); } });

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('open')) { return; }
      if (e.key === 'Escape') { lbHide(); return; }
      if (e.key === 'Tab') { e.preventDefault(); lbClose.focus(); }
    });
  }

  /* ── 3. Scroll reveal (opt-in) ────────────────────────────────────────── */
  if (root.getAttribute('data-reveal') !== 'true') { return; }

  var targets = root.querySelectorAll('.sg-reveal');
  if (!targets.length) { return; }
  if (reduceMotion || !('IntersectionObserver' in window)) { return; }

  root.classList.add('sg-anim');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  Array.prototype.forEach.call(targets, function (el) { io.observe(el); });

  /* Safety net: show everything if the observer misbehaves. */
  window.setTimeout(function () {
    Array.prototype.forEach.call(targets, function (el) { el.classList.add('in'); });
  }, 4000);
})();